export default __webpack_public_path__ + "static/media/08.d95aacbe.jpg";